import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppInjector } from '../utils/app.injector';
import { BaseComponent } from './base.component';

@Component({
    template: ''
})
export abstract class BaseFormComponent extends BaseComponent implements OnInit, OnDestroy {

    protected formBuilder: FormBuilder = AppInjector.get(FormBuilder);

    form: FormGroup;

    constructor() {
        super();
    }

    ngOnInit() {
        this.initForm();
    }

    ngOnDestroy() {
    }

    initForm() {
        this.form = this.formBuilder.group(this.getFormControls(), {});
    }

    removeEmptySpaces(formControl: any) {
        const value = formControl.value;
        if (value && typeof value === 'string') {
            formControl.setValue(value.toString().trim());
        }
    }

    /**
     * @description Checks if a field has any error
     * @param field The field to be checked
     * @returns The css class name to be put in the app-input-error component.
     */
    hasError(field: FormControl | AbstractControl): string {
        if (field.invalid && (field.dirty || field.touched)) {
            return 'has-error';
        }
    }

    /**
     * @description Check if the formGroupControl has any errors
     * @param formGroupControl The form group control to be checked
     */
    hasAnyError(formGroupControl: any) {
        return Object.keys(formGroupControl)
            .map((item: any) => {
                if (formGroupControl[item] instanceof FormControl) {
                    return formGroupControl[item];

                } else if (formGroupControl[item] instanceof FormArray) {
                    const formArrayItems = formGroupControl[item] as FormArray;
                    return formArrayItems.controls.map((groupItem: FormGroup) => {
                        return this.hasAnyError(groupItem.controls);
                    });

                } else if (formGroupControl[item] instanceof FormGroup) {
                    return this.hasAnyError(formGroupControl[item].controls);
                }
            })
            .filter((item) => {
                if (item instanceof Array) {
                    return item.some(arrayItem => arrayItem);
                }
                return item.touched && !!item.errors;
            }).length > 0;
    }

    abstract getFormControls();

    abstract onSubmit();
}
